import { ResultOf } from "gql.tada";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { MediaItem } from "@components/shared/MediaItem";
import { Link } from "@components/shared/core/Link";
import { Button } from "@components/shared/core/Button";

type IconCtaSectionEntry = {
  title?: string | null;
  description?: string | null;
  variant?: string | null;
  ctaLink?: ResultOf<typeof LinkFragment> | null;
  iconGrid?: ResultOf<typeof IconGridFragment> | null;
};

export const IconCtaSection = ({
  entry,
}: {
  entry: { iconCtaSection: IconCtaSectionEntry };
}) => {
  const section = entry.iconCtaSection;
  if (!section) return null;

  const icons = section.iconGrid?.iconsCollection?.items ?? [];

  return (
    <section className="grid-base container-base py-[120px] bg-palette-current-deep/20">
      <div className="col-span-full dsk:col-span-7 dsk:col-start-2 [&_*]:text-brand-cream">
        {section.title && (
          <h4 className="text-heading-4 [*+&]:mt-5">{section.title}</h4>
        )}
        {section.description && (
          <p className="text-body-small [*+&]:mt-5">{section.description}</p>
        )}
        {section.ctaLink && (
          <Button asChild variant="light-on-blur" className="mt-[38px]">
            <Link link={section.ctaLink}>{section.ctaLink.text}</Link>
          </Button>
        )}
      </div>

      <div className="col-span-full dsk:col-span-10 dsk:col-start-14 [&_*]:text-brand-cream">
        <div className="grid grid-cols-2 dsk:grid-cols-3">
          {icons.map((icon) => {
            if (!icon?.asset) return null;
            return (
              <div
                key={icon._id}
                className="max-w-[123px] dsk:max-w-[158px] aspect-square flex justify-center items-center"
              >
                <MediaItem
                  item={icon.asset}
                  className="w-full h-auto"
                  width={160}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
